import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DeviceStatusOnlineDetails } from '../services/getDeviceStatusOnlineService'

export interface DeviceStatusOnlineDataState {
  isLoading: boolean
  loadingError: string | undefined
  DeviceStatusOnlineData: DeviceStatusOnlineDetails | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: DeviceStatusOnlineDataState = {
  isLoading: false,
  loadingError: undefined,
  DeviceStatusOnlineData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const DeviceStatusOnlineDataListState = createSlice({
  name: 'DeviceStatusOnlineData',
  initialState,
  reducers: {
    DeviceStatusOnlineLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        DeviceStatusOnlineData: undefined,
        httpStatus: 0
      }
    },
    DeviceStatusOnlineUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        DeviceStatusOnlineData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    DeviceStatusOnlineErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        DeviceStatusOnlineData: undefined
      }
    },
    DeviceStatusOnlineWebSocketUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: undefined,
        DeviceStatusOnlineData: action.payload,
        httpStatus: 200
      }
    }
  }
})

// Actions to export
export const {
  DeviceStatusOnlineLoadingAction,
  DeviceStatusOnlineUpdateAction,
  DeviceStatusOnlineErrorAction,
  DeviceStatusOnlineWebSocketUpdateAction
} = DeviceStatusOnlineDataListState.actions

export default DeviceStatusOnlineDataListState.reducer
